<mat-form-field floatLabel="always" class="textbox"
                [style]="textArea.inlineStyle ? layoutElemeneUtil.translateStyle(textArea.inlineStyle):''"
                appearance="outline">
  <mat-label class="custom-form-caption-label">{{ textArea.caption }}</mat-label>
  <textarea [(ngModel)]="textArea.content"
            [maxlength]="textArea.maxChars === 0 ? null : textArea.maxChars!"
            [rows]="textArea.rows" [disabled]="layoutElemeneUtil.ReadonlyMode"
            (ngModelChange)="fire($event)" matInput></textarea>

  <app-character-counter *ngIf="textArea.maxCharsWarning && textArea.maxChars"
                         [maxChars]="textArea.maxChars"
                         [maxCharsWarning]="textArea.maxCharsWarning"
                         [charSequenceLength]="textArea!.content!.length"
                         [isArdPopnacht]="textArea.isArdPopnacht"></app-character-counter>
  @if (textArea.showKiRefreshButton) {
    <button aria-label="Erneut Laden" matTooltip="Erneut Laden" mat-icon-button [disabled]="layoutElemeneUtil.ReadonlyMode || ((loading$ | async)?.showProgressbar)" style="display: inline-flex" (click)="fireKiEvent($event, false)">
      <mat-icon aria-label="Erneut Laden">replay</mat-icon>
    </button>
    <button aria-label="Erneut Laden Text verkürzen" matTooltip="Erneut Laden Text verkürzen" mat-icon-button [disabled]="layoutElemeneUtil.ReadonlyMode || ((loading$ | async)?.showProgressbar)" style="display: inline-flex" (click)="fireKiEvent($event, true)">
      <mat-icon>replay_10</mat-icon>
    </button>
  }

</mat-form-field>
